import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Flashlight } from '@bibliocommons/deprecated-base-icons';
import { ExpandablePanel } from '@bibliocommons/deprecated-expandable';
import { searchEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { didNotFindOptionsShape } from '@bibliocommons/bc-prop-types';
import ChatWidgetButton from '../ChatWidgetButton';
import DidNotFind from '../DidNotFind';

import './DidNotFindExpandablePanel.scss';

function handleToggle({ expanded }) {
  sendAnalyticsEvents(searchEventComposer.composeDidNotFindPanelToggleEvent({ expanded }));
}

function renderTriggerContent() {
  return <FormattedMessage id="did_not_find_discover" />;
}

function renderChatWidgetButton(chatWidgets) {
  const enabledWidget = chatWidgets.findLastKey(widget => widget.get('enabled'));

  if (enabledWidget) {
    return (
      <span className="did-not-find-collapible-chat-widget">
        <ChatWidgetButton widget={enabledWidget} />
      </span>
    );
  }

  return null;
}

function renderHeader(chatWidgets) {
  return (
    <div className="did-not-find-heading-content">
      <div className="panel-title">
        <Flashlight />
        <FormattedMessage id="did_not_find_heading" />
      </div>
      {renderChatWidgetButton(chatWidgets)}
    </div>
  );
}

export default function DidNotFindExpandablePanel({ query, didNotFindOptions, chatWidgets }) {
  return (
    <ExpandablePanel
      className="did-not-find-expandable-panel"
      renderHeaderContent={() => renderHeader(chatWidgets)}
      renderExpandButtonLabel={() => renderTriggerContent()}
      handleToggle={handleToggle}
    >
      <DidNotFind query={query} didNotFindOptions={didNotFindOptions} />
    </ExpandablePanel>
  );
}

DidNotFindExpandablePanel.propTypes = {
  query: PropTypes.string,
  didNotFindOptions: didNotFindOptionsShape,
  chatWidgets: ImmutablePropTypes.mapOf(PropTypes.object)
};
